import React from 'react';

import { TProfile } from 'api/http-client/profileTypes';
import { useRedirectAndScroll } from 'hooks';

import userProfileStyles from "../styles.module.scss";
import styles from './styles.module.scss';
import { useTranslates } from 'providers/translates';
import MarkdownRenderer from 'components/MarkdownRenderer';
import { Language } from 'providers/translates/enums';
import { isVac } from 'utilities/is-vac';
import { Helmet } from 'react-helmet-async';

const translationsHelmet = {
  titleEN: 'Saluting Service - Your profile',
  titleFR: 'Saluons leur service - Votre profil'
} as const;

export const Welcome: React.FC<{ user: TProfile | null }> = ({ user }) => {
  const { redirectAndScroll } = useRedirectAndScroll({});
  const { translates: t, selectedLang } = useTranslates();
  const isFrench = selectedLang === Language.FRENCH;

  const welcomeUser = t?.welcomeUser;

  return (
    <>
    {isVac() && (
      <Helmet>
        <title>{isFrench ? translationsHelmet?.titleFR : translationsHelmet?.titleEN}</title>
      </Helmet>
    )}
    <section className={styles.welcome_container}>
      <div className={styles.text_wrapper}>
        <h2 className={userProfileStyles.tab_title}>{welcomeUser?.welcomeUserHeading ?? 'Welcome'} {user?.firstName}.</h2>
        {welcomeUser?.welcomeUserContent ? (
          <MarkdownRenderer 
            content={welcomeUser?.welcomeUserContent} 
          />
        ) : (
          <>
            <p className={styles.welcome_text}>
              Thank you for creating a memorial quilt square to honour someone who has died and
              contribute to a national quilt of honouring, remembering, and healing.
            </p>
            <p className={styles.welcome_text}>
              As a first step, fill in the person’s name and invite others you’d like to help create the
              memorial.
            </p>
            <p className={styles.welcome_text}>Next add details, photos, memories, and more.</p>
            <p className={styles.welcome_text}>
              When your quilt square is finished, it can be shared publicly as part of the Canadian
              Healing Quilt or privately with those you choose.
            </p>
          </>
        )}
        <button
          className={`customButton ${styles.start_button}`}
          onClick={() => redirectAndScroll('/create?step=1')}
        >
          {welcomeUser?.welcomeUserStartBtn ?? 'Start Now'}
        </button>
      </div>
    </section>
    </>
  );
};
